import { useState, useEffect } from "react";
import api from "../api";

const BRL = n => (Number(n)||0).toLocaleString("pt-BR",{ style:"currency", currency:"BRL", maximumFractionDigits:2 });
const ORANGE = "#EE6A1A";
const mesAtual = () => new Date().toISOString().slice(0,7);
const shiftMes = (m,d) => { const [y,mo]=m.split("-").map(Number); return new Date(y, mo-1+d, 1).toISOString().slice(0,7); };
const fmtData = s => { if(!s||s.length<10) return "—"; const [y,m,d]=s.slice(0,10).split("-"); return d+"/"+m+"/"+y; };
const startMes = r => ((r.data||"").length>=7 ? r.data.slice(0,7) : (r.mes||""));

const CATS_DESP = ["Moradia","Alimentação","Transporte","Saúde","Educação","Lazer","Cartão","Assinaturas","Impostos","Outros"];
const CATS_REC  = ["Salário","Pró-labore","Investimentos","Aluguel recebido","Outros"];

const card = { background:"var(--card-bg)", border:"1px solid var(--border-color)", borderRadius:14, padding:20, boxShadow:"0 1px 3px rgba(0,0,0,.04)" };
const lbl  = { fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".04em", display:"block", marginBottom:5 };
const inp  = { width:"100%", boxSizing:"border-box", background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"9px 11px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif", height:38 };
const secTit= { fontSize:12, fontWeight:800, color:ORANGE, textTransform:"uppercase", letterSpacing:".05em", marginBottom:14 };
const th = { fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".03em", textAlign:"left", padding:"8px", borderBottom:"1px solid var(--border-color)" };
const td = { fontSize:13, color:"var(--text-secondary)", padding:"9px 8px", borderTop:"1px solid var(--border-light)" };
const btnAdd = { height:38, background:ORANGE, border:"none", borderRadius:8, padding:"0 16px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", whiteSpace:"nowrap" };
const iconBtn = { cursor:"pointer", fontSize:14, padding:"0 4px" };

function Money({ value, onChange, style }){
  const disp = (value===""||value==null||Number(value)===0) ? "" : BRL(value);
  return <input value={disp} placeholder="R$ 0,00" style={{ ...inp, textAlign:"right", ...style }}
    onChange={e=>{ const d=e.target.value.replace(/\D/g,""); onChange(d? Number(d)/100 : 0); }}/>;
}

export default function FinancaPessoal(){
  const [regs,setRegs] = useState([]);
  const [mes,setMes]   = useState(mesAtual);
  const vazio = { tipo:"despesa", descricao:"", categoria:"", valor:"", data:"", recorrente:false, status:"pago" };
  const [f,setF] = useState(vazio);
  const [editId,setEditId] = useState(null);

  const carregar = async()=>{ try{ const {data}=await api.get("/financa-pessoal"); setRegs(Array.isArray(data)?data:[]); }catch(e){ setRegs([]); } };
  useEffect(()=>{ carregar(); },[]);

  const doMes = regs.filter(r => r.recorrente ? (startMes(r) && startMes(r) <= mes) : ((r.mes||startMes(r)) === mes));
  const receitas = doMes.filter(r=>r.tipo==="receita").reduce((a,r)=>a+Number(r.valor||0),0);
  const despesas = doMes.filter(r=>r.tipo==="despesa").reduce((a,r)=>a+Number(r.valor||0),0);
  const saldo = receitas - despesas;

  const salvar = async()=>{
    if(!f.descricao.trim() && !f.valor) return;
    const dataRef = f.data || (mes+"-01");
    const body = { tipo:f.tipo, descricao:f.descricao, categoria:f.categoria||"Outros", valor:Number(f.valor)||0, data:dataRef, mes: dataRef.slice(0,7), recorrente:!!f.recorrente, status:f.status };
    try{ if(editId) await api.put("/financa-pessoal/"+editId, body); else await api.post("/financa-pessoal", body); }
    catch(e){ return alert("Não foi possível salvar."); }
    setF(vazio); setEditId(null); carregar();
  };
  const editar = (r)=>{ setEditId(r._id); setF({ tipo:r.tipo, descricao:r.descricao||"", categoria:r.categoria||"", valor:r.valor||"", data:(r.data||"").slice(0,10), recorrente:!!r.recorrente, status:r.status||"pago" }); };
  const excluir = async(id)=>{ if (!window.confirm("Excluir este lançamento?")) return; try{ await api.delete("/financa-pessoal/"+id); }catch(e){} carregar(); };

  const cats = f.tipo==="receita" ? CATS_REC : CATS_DESP;

  return (
    <div style={{ fontFamily:"'Inter',sans-serif", padding:"20px 24px 60px", maxWidth:1100, margin:"0 auto" }}>

      <div style={{ ...card, marginBottom:16, display:"flex", alignItems:"center", gap:16, flexWrap:"wrap" }}>
        <div>
          <label style={lbl}>Mês</label>
          <div style={{ display:"flex", alignItems:"center", gap:6 }}>
            <button onClick={()=>setMes(shiftMes(mes,-1))} style={{ ...inp, width:38, padding:0, cursor:"pointer", fontSize:18, fontWeight:700, color:"var(--text-secondary)", display:"flex", alignItems:"center", justifyContent:"center" }}>‹</button>
            <input type="month" value={mes} onChange={e=>setMes(e.target.value)} style={{ ...inp, width:160 }}/>
            <button onClick={()=>setMes(shiftMes(mes,1))} style={{ ...inp, width:38, padding:0, cursor:"pointer", fontSize:18, fontWeight:700, color:"var(--text-secondary)", display:"flex", alignItems:"center", justifyContent:"center" }}>›</button>
          </div>
        </div>
        <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:6, fontSize:12, color:"var(--text-muted)" }}>
          <span style={{ fontSize:16 }}>🔒</span> Privado — só você vê estes lançamentos
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, marginBottom:16 }}>
        {[["Receitas",receitas,"#10b981"],["Despesas",despesas,"#e2445c"],["Saldo do mês",saldo, saldo>=0?"#10b981":"#e2445c"]].map(([k,v,c],i)=>(
          <div key={i} style={{ ...card, padding:16 }}>
            <div style={{ fontSize:10.5, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".04em" }}>{k}</div>
            <div style={{ fontSize:22, fontWeight:800, color:c, marginTop:6 }}>{BRL(v)}</div>
          </div>
        ))}
      </div>

      <div style={{ ...card, marginBottom:16 }}>
        <div style={secTit}>Lançamentos de {mes}</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr>
            <th style={{...th,textAlign:"center"}}>Data</th>
            <th style={th}>Descrição</th>
            <th style={th}>Categoria</th>
            <th style={{...th,textAlign:"center"}}>Tipo</th>
            <th style={{...th,textAlign:"right"}}>Valor</th>
            <th style={{...th,width:64,textAlign:"center"}}></th>
          </tr></thead>
          <tbody>
            {doMes.map(r=>(
              <tr key={r._id} style={{ background: editId===r._id?ORANGE+"0d":"transparent" }}>
                <td style={{...td,textAlign:"center"}}>{fmtData(r.data)}</td>
                <td style={{...td,color:"var(--text-primary)",fontWeight:600}}>
                  {r.descricao||"—"}
                  {r.recorrente && <span style={{ marginLeft:8, fontSize:10, fontWeight:700, color:"#6c5ce7", background:"#6c5ce71a", borderRadius:99, padding:"1px 7px" }}>fixo</span>}
                  {r.status==="pendente" && <span style={{ marginLeft:6, fontSize:10, fontWeight:700, color:"#EE6A1A", background:"#EE6A1A1a", borderRadius:99, padding:"1px 7px" }}>pendente</span>}
                </td>
                <td style={td}>{r.categoria||"—"}</td>
                <td style={{...td,textAlign:"center",fontWeight:700,color: r.tipo==="receita"?"#10b981":"#e2445c"}}>{r.tipo==="receita"?"Receita":"Despesa"}</td>
                <td style={{...td,textAlign:"right",fontWeight:800,color: r.tipo==="receita"?"#10b981":"#e2445c"}}>{r.tipo==="receita"?"+ ":"− "}{BRL(r.valor)}</td>
                <td style={{...td,textAlign:"center",whiteSpace:"nowrap"}}>
                  <span onClick={()=>editar(r)} style={{...iconBtn,color:"#579bfc"}}>✎</span>
                  <span onClick={()=>excluir(r._id)} style={{...iconBtn,color:"#e2445c"}}>×</span>
                </td>
              </tr>
            ))}
            {doMes.length===0 && <tr><td style={{...td,color:"var(--text-muted)"}} colSpan={6}>Nenhum lançamento neste mês.</td></tr>}
          </tbody>
        </table>

        <div style={{ display:"grid", gridTemplateColumns:"120px 1fr 150px 150px 130px 120px", gap:10, alignItems:"end", marginTop:16, paddingTop:16, borderTop:"1px solid var(--border-light)" }}>
          <div><label style={lbl}>Tipo</label>
            <select value={f.tipo} onChange={e=>setF({...f,tipo:e.target.value,categoria:""})} style={{...inp,appearance:"auto"}}>
              <option value="despesa">Despesa</option>
              <option value="receita">Receita</option>
            </select>
          </div>
          <div><label style={lbl}>Descrição {editId&&<span style={{color:ORANGE}}>· editando</span>}</label><input value={f.descricao} onChange={e=>setF({...f,descricao:e.target.value})} placeholder="Ex: Aluguel, mercado, salário..." style={inp}/></div>
          <div><label style={lbl}>Categoria</label>
            <select value={f.categoria} onChange={e=>setF({...f,categoria:e.target.value})} style={{...inp,appearance:"auto"}}>
              <option value="">—</option>
              {cats.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div><label style={lbl}>Valor</label><Money value={f.valor} onChange={v=>setF({...f,valor:v})}/></div>
          <div><label style={lbl}>Data</label><input type="date" value={f.data} onChange={e=>setF({...f,data:e.target.value})} style={inp}/></div>
          <div style={{ display:"flex", gap:6 }}>
            <button onClick={salvar} style={btnAdd}>{editId?"Salvar":"+ Add"}</button>
            {editId&&<button onClick={()=>{ setEditId(null); setF(vazio); }} style={{...btnAdd, background:"var(--hover-bg)", color:"var(--text-secondary)", padding:"0 10px"}}>✕</button>}
          </div>
        </div>
        <div style={{ display:"flex", gap:16, marginTop:12 }}>
          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"var(--text-secondary)", cursor:"pointer" }}>
            <input type="checkbox" checked={f.recorrente} onChange={e=>setF({...f,recorrente:e.target.checked})}/> Despesa/receita fixa mensal (repete todo mês)
          </label>
          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"var(--text-secondary)", cursor:"pointer" }}>
            <input type="checkbox" checked={f.status==="pendente"} onChange={e=>setF({...f,status:e.target.checked?"pendente":"pago"})}/> Marcar como pendente
          </label>
        </div>
      </div>
    </div>
  );
}
